export default "__VITE_ASSET__BTj14NE8__"